// extracted by mini-css-extract-plugin
export default {"background":"styles_background__uf04q","backgroundActive":"styles_backgroundActive__N1y3N","picture":"styles_picture__M1d-h","pictureActive":"styles_pictureActive__tws7S"};